export const checkIfIframe = () => window.location !== window.parent.location;
